/* tslint:disable */
/* eslint-disable */
export enum FileType {
  VatReport = 'VAT_REPORT',
  TripReport = 'TRIP_REPORT',
  Invoice = 'INVOICE',
  GhSalesInvoiceReport = 'GH_SALES_INVOICE_REPORT',
  GhSalesWorkOrderReport = 'GH_SALES_WORK_ORDER_REPORT',
  GhReport = 'GH_REPORT',
  LegWiseReport = 'LEG_WISE_REPORT',
  OracleWebAdi = 'ORACLE_WEB_ADI',
  AcmsFlightReport = 'ACMS_FLIGHT_REPORT',
  CharterContractReport = 'CHARTER_CONTRACT_REPORT',
}
